/**
 * 将年级和班级转换为中文格式字符串
 * @param {number} grade - 年级数字(1-12)
 * @param {string} className - 班级
 * @returns {string} 格式化后的中文班级字符串，如"一年级2班"
 */
export function formatGradeAndClass(grade, className) {
  const normalizedGrade = Number(grade)
  const normalizedClassName = className == null ? "" : String(className).trim()

  // 验证输入是否为有效数字
  if (
    !Number.isInteger(normalizedGrade) ||
    normalizedGrade < 1 ||
    normalizedGrade > 12
  ) {
    console.error("无效的年级或班级数字")
    return ""
  }

  // 数字转中文映射
  const chineseNumbers = [
    "",
    "一年级",
    "二年级",
    "三年级",
    "四年级",
    "五年级",
    "六年级",
    "初一",
    "初二",
    "初三",
    "高一",
    "高二",
    "高三",
  ]

  // 拼接结果
  return `${chineseNumbers[normalizedGrade]}${normalizedClassName}`
}
